import { Maybe } from '@/types/codegen-federation'

export function hasSeasonEarlyAccess(
  earlyAccessGroup: string | undefined,
  allowedGroups?: Array<{ name?: string | null } | null> | null,
) {
  if (!earlyAccessGroup) return false

  const userGroups = allowedGroups?.flatMap((group) => group?.name) || []
  return userGroups.includes(earlyAccessGroup)
}

interface GetUserDisplayUser {
  profile?: Maybe<{
    lastName?: Maybe<string>
    firstName?: Maybe<string>
  }>
  lastName?: Maybe<string>
  firstName?: Maybe<string>
  email?: Maybe<string>
}

export const getUserFirstName = (user?: Maybe<GetUserDisplayUser>, defaultName = ''): string => {
  return user?.firstName || user?.profile?.firstName || defaultName
}

export const getUserLastName = (user?: Maybe<GetUserDisplayUser>, defaultName = ''): string => {
  return user?.lastName || user?.profile?.lastName || defaultName
}

export function getUserDisplayName(user?: Maybe<GetUserDisplayUser>, defaultName = ''): string {
  const firstName = getUserFirstName(user)
  const lastName = getUserLastName(user)
  return formatUserFullName(firstName, lastName) ?? defaultName
}

export function formatUserFullName(firstName?: string, lastName?: string): string | undefined {
  if (firstName && lastName) return `${firstName} ${lastName}`
  if (firstName) return firstName
  if (lastName) return lastName
}

export function getUserDisplayNameOrEmail(user?: Maybe<GetUserDisplayUser>, defaultName = ''): string {
  const displayName = getUserDisplayName(user)
  if (displayName) return displayName
  if (user?.email) return user.email
  return defaultName
}

export const getIsAngelEmployeeUser = (email: string | null | undefined) => {
  if (!email) return false
  return /@angel.com$/.test(email)
}
